import { render, staticRenderFns } from "./ZxdetailsView.vue?vue&type=template&id=d7d951a2&scoped=true&"
import script from "./ZxdetailsView.vue?vue&type=script&lang=js&"
export * from "./ZxdetailsView.vue?vue&type=script&lang=js&"
import style0 from "./ZxdetailsView.vue?vue&type=style&index=0&id=d7d951a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d951a2",
  null
  
)

export default component.exports